import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    if (stored && token) {
      const parsed = JSON.parse(stored);
      setUser(parsed);
      // If stored user is missing id or newer fields (older sessions), refetch full profile
      if (!parsed.id || parsed.receives_bonuses === undefined) {
        auth.me()
          .then((r) => {
            localStorage.setItem('user', JSON.stringify(r.data));
            setUser(r.data);
          })
          .catch(() => {
            // Token expired or invalid — clear
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setUser(null);
          });
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const res = await auth.login(username, password);
    const { access_token } = res.data;
    localStorage.setItem('token', access_token);
    // Fetch full user profile (including id) from /auth/me
    const meRes = await auth.me();
    const userData = meRes.data; // {id, username, full_name, role, ...}
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  // (f) after "sign in again": pick up the user written to localStorage
  const refreshUser = () => {
    try {
      const stored = JSON.parse(localStorage.getItem('user') || 'null');
      if (stored) setUser(stored);
    } catch (_e) { /* keep the current user */ }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
